import { FC } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { FactoryVerificationStepRailState } from '@/utils/factoryVerificationStepRail.util';
import styles from './FactoryVerificationStepRail.module.scss';

type FactoryVerificationStepRailProps = {
  step1State: FactoryVerificationStepRailState;
  step2State: FactoryVerificationStepRailState;
};

type StepNodeProps = {
  stepNumber: 1 | 2;
  label: string;
  state: FactoryVerificationStepRailState;
};

const stepNodeClassByState: Record<FactoryVerificationStepRailState, string> = {
  upcoming: 'stepNodeUpcoming',
  active: 'stepNodeActive',
  complete: 'stepNodeComplete',
};

const StepNode: FC<StepNodeProps> = ({ stepNumber, label, state }) => {
  const isActive = state === 'active';
  const isComplete = state === 'complete';
  return (
    <li
      className={`${styles.stepNode} ${styles[stepNodeClassByState[state]]}`}
      aria-current={isActive ? 'step' : undefined}
    >
      <span className={styles.stepMarker} aria-hidden="true">
        {isComplete ? <CheckIcon className={styles.checkIcon} /> : stepNumber}
      </span>
      <span className={styles.stepLabel}>{label}</span>
    </li>
  );
};

export const FactoryVerificationStepRail: FC<FactoryVerificationStepRailProps> = ({
  step1State,
  step2State,
}) => {
  const { t } = useTranslation();
  return (
    <ol className={styles.rail} aria-label={t('factory_verification_title')}>
      <StepNode
        stepNumber={1}
        label={t('factory_verification_step_entrance_label')}
        state={step1State}
      />
      <li className={styles.connector} aria-hidden="true" />
      <StepNode
        stepNumber={2}
        label={t('factory_verification_step_room_label')}
        state={step2State}
      />
    </ol>
  );
};
